import { render } from "./courseScreens.vue?vue&type=template&id=99248cca&scoped=true&ts=true"
import script from "./courseScreens.vue?vue&type=script&lang=ts"
export * from "./courseScreens.vue?vue&type=script&lang=ts"

import "./courseScreens.vue?vue&type=style&index=0&id=99248cca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99248cca"]])

export default __exports__